// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mJfVyITSdlMuFf93utsd {
  color: var(--top-block-font-color);
  overflow-wrap: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/components/HeroTitle/HeroTitle.module.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B","sourcesContent":[".heroTitle {\n  color: var(--top-block-font-color);\n  overflow-wrap: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heroTitle": `mJfVyITSdlMuFf93utsd`
};
export default ___CSS_LOADER_EXPORT___;
